import React, { useEffect, useState, useRef, useMemo } from "react";
import style from "../styles.module.scss";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { useSelector, useDispatch } from "react-redux";
import axios from 'util/axios';

import Row from "../datatable/DataTable";

import update from "immutability-helper";

import ModalPortal from "util/component/Modal";
import { Modal, ConfirmWithMessage } from "util/component/Modal/Modal";

import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpWideShort, faArrowDownWideShort } from "@fortawesome/free-solid-svg-icons";

const post = async ({ api, body, message }, getFunc, onError) => {
    const response = await axios.post(process.env.REACT_APP_API + api, { ...body, message });
    if (response.status.toString() === "200") {
        if (response.data.data.result?.toString().includes("ERR")) {
            onError(response.data.data.result.toString());
        } else {
            getFunc && getFunc();
        }
    } else {
        onError("Server Code : " + response.status.toString());
    }
};

const targetColumn = [{ col: "orderBy" }, { col: "code", readOnly: true, selectAble: true }, { col: "cdNm" }, { col: "description" }];
const FilterInitial = { code: "", cdNm: "", description: "" };

const UnitOpretionTable = () => {
    const { t } = useTranslation(["page"]);
    const user = useSelector((store) => store.user);
    const mTable = useSelector((store) => store.masterTable);
    const dispatch = useDispatch();

    const [TableData, SetTableData] = useState([]);
    const [MoveAble, SetMoveAble] = useState(false);

    const [NewParam, SetNewParam] = useState({ code: "", description: "", cdNm: "" });

    const ModalMessage = useRef(null);
    const tempData = useRef(null);

    const rendering = !!mTable.proc && mTable.proc.match(/(USP|DSP)/);

    const [ModalOpen, SetModalOpen] = useState(false);

    const onError = (message) => {
        ModalMessage.current = t(message);
        SetModalOpen("modal");
    };

    const [Filter, SetFilter] = useState(FilterInitial);
    const [OrderBy, SetOrderBy] = useState(null);


    const getUnitOperation = async () => {
        const response = await axios.post(process.env.REACT_APP_API + "/common/retrieveMasterCodeList", { grcd: mTable.proc });
        const data = response.data.data.result;
        let code;

        try {
            if (data.length < 2) {
                code = data[0].code;
            } else {
                code = data.reduce((prev, value) => {
                    return prev.code >= value.code ? prev : value;
                });
                code = code.code;
            }
        } catch (e) {
            code = mTable.proc + "00";
        }
        code = parseInt(code.toString().replace(mTable.proc, "")) + 1;
        if (code < 10) {
            code = "0" + code;
        }
        code = mTable.proc + code;
        SetModalOpen(false);
        SetNewParam({ code: code, description: "", cdNm: "" });
        dispatch({ type: "setMaster", uo: null, step: null });
        SetMoveAble(false);
        if (!!OrderBy?.name || Object.keys(Filter)?.filter((e) => !!Filter[e]).length > 0) {
            filterAndOrderBy(data);
        } else {
            SetTableData(data);
        }
    };

    const action = (args) => {
        const { type } = args;
        switch (type.toString().toLowerCase()) {
            case "change":
                SetTableData((d) =>
                    update(d, {
                        [args.index]: { $set: { ...d[args.index], ...{ [args.name]: args.value.toString().trim(), isUpdate: true } } },
                    })
                );
                break;
            case "move":
                SetTableData((d) =>
                    update(d, {
                        $splice: [
                            [args.dragIndex, 1],
                            [args.hoverIndex, 0, d[args.dragIndex]],
                        ],
                    })
                );
                SetMoveAble(true);
                break;
            case "select":
                dispatch({ type: "setMaster", uo: TableData[args.index].code, step: null });
                const fi = TableData.findIndex((v) => v.selected);
                SetTableData((d) =>
                    update(d, {
                        [fi]: { $set: { ...d[fi], selected: false } },
                        [args.index]: { $set: { ...d[args.index], selected: true } },
                    })
                );
                break;
            case "updatecomplete":
                SetTableData((d) => {
                    const next = update(d, {
                        [args.index]: { $set: { ...d[args.index], isUpdate: false } },
                    });
                    tempData.current = {
                        api: "/common/modifyMasterCodeNm",
                        body: {
                            groupCd: mTable.proc,
                            code: next[args.index].code,
                            cdNm: next[args.index].cdNm,
                            description: next[args.index].description,
                            userId: user.userId,
                        },
                    };
                    ModalMessage.current = t("modifyConfirm");
                    SetModalOpen("confirm");
                    return next;
                });
                break;
            case "disable":
                tempData.current = {
                    api: "/common/modifyMasterCodeDisableYn",
                    body: {
                        groupCd: mTable.proc,
                        code: TableData[args.index].code,
                        disableYn: TableData[args.index].disableYn === "N" ? "Y" : "N",
                        userId: user.userId,
                    },
                };
                ModalMessage.current = t("statusConfirm");
                SetModalOpen("confirm");
                break;
            default:
                console.error("No type [" + type + "]");
        }
    };

    const insertMasterCode = () => {
        const { code, cdNm, description } = NewParam;
        if (!!!code || !!!cdNm || !!!description) {
            ModalMessage.current = t("emptyConfirm");
            SetModalOpen("modal");
        } else {
            let orderBy;

            try {
                if (TableData.length < 2) {
                    orderBy = TableData.length + 1;
                } else {
                    const orderByNum = TableData.reduce((prev, value) => {
                        return prev.orderBy >= value.orderBy ? prev.orderBy : value.orderBy;
                    });
                    orderBy = parseInt(orderByNum) + 1;
                }
            } catch (e) {
                orderBy = 1;
            }

            if (isNaN(orderBy)) orderBy = 1;

            tempData.current = {
                api: "/common/createMasterCode",
                body: {
                    groupCd: mTable.proc,
                    code,
                    cdNm,
                    description,
                    orderBy,
                    userId: user.userId,
                },
            };
            ModalMessage.current = t("addConfirm");
            SetModalOpen("confirm");
        }
    };

    const setOrderBy = () => {
        let newD = TableData.map((v, i) => {
            return {
                groupCd: mTable.proc,
                code: v.code,
                orderBy: i + 1,
                userId: user.userId,
            };
        });
        tempData.current = {
            api: "/common/modifyMasterCodeOrderBy",
            body: { master: newD },
        };
        ModalMessage.current = t("ChangeOrderConfirm");
        SetModalOpen("confirm");
    };

    const renderTable = useMemo(() => {
        const disabled = !!OrderBy?.name || Object.keys(Filter)?.filter((e) => !!Filter[e]).length > 0;
        const row = TableData.map((v, i) => {
            return <Row key={"unitOpTable" + i} hide={v?.hide} disabled={user.isAdmin ? disabled : true} index={i} rowData={v} targetCol={targetColumn} action={action} admin={user.isAdmin} />;
        });
        return row;
    }, [TableData]);

    // Filter, OrderBy 변경
    useEffect(() => {
        filterAndOrderBy();
    }, [Filter, OrderBy])

    const filterAndOrderBy = (d) => {
        let data;

        TableData.map(data=>{
            data.hide = false;
        })
        if (!!d) {
            data = d;
        } else {
            data = [...TableData];
        }
        if (!!OrderBy?.name) {
            data = data.sort((prev, next) => {
                if (prev[OrderBy.name] > next[OrderBy.name]) return 1;
                if (prev[OrderBy.name] < next[OrderBy.name]) return -1;
                return 0;
            });
            if (OrderBy.type === "DESC") {
                data = data.reverse();
            }
        } else {
            data = data.sort((prev, next) => {
                if (prev.orderBy > next.orderBy) return 1;
                if (prev.orderBy < next.orderBy) return -1;
                return 0;
            });
        }
        Object.keys(Filter).forEach((str) => {

            data = data.map((e) => {
                if (e[str].toString().toLowerCase().includes(Filter[str]?.toString().toLowerCase()) && !e.hide) {
                    return { ...e, hide: false }
                } else {
                    return { ...e, hide: true }
                }

            });

        });
        SetTableData(data);
    }

    useEffect(() => {
        if (rendering) getUnitOperation();
        return () => {
            SetTableData([]);
            SetMoveAble(false);
        };
    }, [mTable.proc]);

    const ModalRender = useMemo(() => {
        const confirmValid = () => {
            return true;
        };
        const onConfirm = async (message) => {
            await post({ ...tempData.current, message }, getUnitOperation, onError);
        };

        if (!ModalOpen) {
            tempData.current = null;
            return null;
        } else {
            if (ModalOpen === "confirm") {
                return (
                    <ConfirmWithMessage onClose={() => SetModalOpen(false)} valid={confirmValid} onConfirm={(msg) => onConfirm(msg)}>
                        <p>{ModalMessage.current}</p>
                    </ConfirmWithMessage>
                );
            } else {
                return <Modal onClose={() => SetModalOpen(false)}>{ModalMessage.current}</Modal>;
            }
        }
    }, [ModalOpen]);

    const changeOrderby = (e) => {
        const dtype = e.target.dataset.type;
        let ord;
        if (dtype === OrderBy?.name) {
            ord = OrderBy?.type === "DESC" ? "ASC" : "DESC";
        } else {
            ord = "DESC";
        }
        SetOrderBy({ name: dtype, type: ord });
    };

    if (!rendering) {
        return <section></section>;
    } else {
        return (
            <section>
                <div className={`${style.mainTable}`}>
                    <DndProvider backend={HTML5Backend}>
                        <table>
                            <colgroup>
                                <col width="40px" />
                                <col width="100px" />
                                <col width="130px" />
                                <col />
                                {user.isAdmin && <col width="150px" />}
                            </colgroup>
                            <thead style={{ position: "sticky", zIndex: "10", top: "0" }}>
                                <tr>
                                    <th colSpan={user.isAdmin ? 5 : 4}>Unit Operation</th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th data-type={"code"} onClick={changeOrderby}>
                                        Code
                                        {OrderBy?.name === "code" && (
                                            <>
                                                &nbsp;
                                                {OrderBy?.type !== "DESC" ? <FontAwesomeIcon icon={faArrowUpWideShort} /> : <FontAwesomeIcon icon={faArrowDownWideShort} />}
                                            </>
                                        )}
                                    </th>
                                    <th data-type={"cdNm"} onClick={changeOrderby}>
                                        Code Name
                                        {OrderBy?.name === "cdNm" && (
                                            <>
                                                &nbsp;
                                                {OrderBy?.type !== "DESC" ? <FontAwesomeIcon icon={faArrowUpWideShort} /> : <FontAwesomeIcon icon={faArrowDownWideShort} />}
                                            </>
                                        )}
                                    </th>
                                    <th data-type={"description"} onClick={changeOrderby}>
                                        Description
                                        {OrderBy?.name === "description" && (
                                            <>
                                                &nbsp;
                                                {OrderBy?.type !== "DESC" ? <FontAwesomeIcon icon={faArrowUpWideShort} /> : <FontAwesomeIcon icon={faArrowDownWideShort} />}
                                            </>
                                        )}
                                    </th>
                                    {
                                        user.isAdmin && <th>
                                            {!!OrderBy?.name || Object.keys(Filter)?.filter((e) => !!Filter[e]).length > 0 ? (
                                                <button
                                                    className={`${style.reset}`}
                                                    onClick={() => {
                                                        SetOrderBy(null);
                                                        SetFilter(FilterInitial);
                                                    }}
                                                >
                                                    Reset
                                                </button>
                                            ) : (
                                                <button disabled={!MoveAble} className={`${style.order}`} onClick={setOrderBy}>
                                                    {t("ChangeOrder")}
                                                </button>
                                            )}
                                        </th>
                                    }

                                </tr>
                                <tr className={`${style.filter}`}>
                                    <td></td>
                                    <td>
                                        <input type="text" placeholder="Filter" value={Filter?.code || ""} onChange={(e) => SetFilter((T) => ({ ...T, code: e.target.value }))} />
                                    </td>
                                    <td>
                                        <input type="text" placeholder="Filter" value={Filter?.cdNm || ""} onChange={(e) => SetFilter((T) => ({ ...T, cdNm: e.target.value }))} />
                                    </td>
                                    <td>
                                        <input type="text" placeholder="Filter" value={Filter?.description || ""} onChange={(e) => SetFilter((T) => ({ ...T, description: e.target.value }))} />
                                    </td>
                                    {user.isAdmin && <td></td>}
                                </tr>
                            </thead>
                            <tbody>

                                {renderTable}
                            </tbody>
                            {
                                user.isAdmin && <tfoot style={{ position: "sticky", zIndex: "10", bottom: "0" }}>
                                    <tr>
                                        <td></td>
                                        <td>
                                            <input
                                                type="text"
                                                name="ucode"
                                                placeholder="Code"
                                                value={NewParam.code}
                                                readOnly
                                                onChange={(e) => {
                                                    SetNewParam((p) => ({ ...p, code: e.target.value }));
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="ucdNm"
                                                placeholder="Code Name"
                                                value={NewParam.cdNm}
                                                onChange={(e) => {
                                                    SetNewParam((p) => ({ ...p, cdNm: e.target.value }));
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="udescription"
                                                placeholder="Description"
                                                value={NewParam.description}
                                                onChange={(e) => {
                                                    SetNewParam((p) => ({ ...p, description: e.target.value }));
                                                }}
                                            />
                                        </td>
                                        <td className={`${style.textCenter}`}>
                                            <button className={`${style.tBtn} ${style.main}`} disabled={MoveAble} onClick={insertMasterCode}>
                                                {t("save")}
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            }

                        </table>
                    </DndProvider>
                </div>
                {!!ModalOpen && <ModalPortal>{ModalRender}</ModalPortal>}
            </section>
        );
    }
};

export default React.forwardRef(UnitOpretionTable);
